<template>
  <div class="change-channel-dialog">
    <el-dialog
      title="渠道变更"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      <el-form :model="formData" :rules="rules" ref="channelForm" label-width="120px" v-loading="loading">
        
        <el-form-item label="当前渠道：">
          <span>{{ currentChannel }}</span>
        </el-form-item>
        
        <el-form-item label="新渠道：" prop="channel_id">
          <el-select
            v-model="formData.channel_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入渠道商名称搜索"
            :remote-method="searchChannel"
            :loading="channelLoading"
            style="width: 100%;"
            clearable>
            <el-option
              v-for="item in channelOptions"
              :key="item.id"
              :label="getChannelDisplayName(item)"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelList, ygbChangeChannel } from '@/api/member.js'

export default {
  name: 'ChangeChannel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitLoading: false,
      channelLoading: false,
      searchTimer: null, // 搜索防抖定时器
      formData: {
        id: '',
        channel_id: ''
      },
      rules: {
        channel_id: [
          { required: true, message: '请选择新渠道', trigger: 'change' }
        ]
      },
      channelOptions: [],
      allChannels: [],
      currentChannel: ''
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initFormData()
        this.getChannelList()
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  },
  methods: {
    initFormData() {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.formData = {
          id: this.rowData.id,
          channel_id: ''
        }
        // 获取当前渠道信息，参考SingleTicketUser.vue的格式
        this.currentChannel = ''
        if (this.rowData.policy_channel) {
          this.currentChannel = this.rowData.policy_channel
          if (this.rowData.alias) {
            this.currentChannel += '(' + this.rowData.alias + ')'
          }
        } else if (this.rowData.alias) {
          this.currentChannel = this.rowData.alias
        }
      }
    },
    async getChannelList(query) {
      try {
        this.channelLoading = true
        const response = await getChannelList()
        
        if (response && response.err_code === 0) {
          this.allChannels = response.rows || []
          
          if (query) {
            // 搜索过滤，参考其他组件的实现
            this.channelOptions = this.allChannels.filter(item => {
              const name = item.realname || item.name || ''
              const alias = item.alias || ''
              const searchStr = (name + alias).toLowerCase()
              return searchStr.includes(query.toLowerCase())
            })
          } else {
            this.channelOptions = this.allChannels
          }
        } else {
          this.$message.error(response.err_msg || '获取渠道列表失败')
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        this.$message.error('获取渠道列表失败: ' + (error.message || '未知错误'))
      } finally {
        this.channelLoading = false
      }
    },
    searchChannel(query) {
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      
      // 设置防抖，300ms后执行搜索
      this.searchTimer = setTimeout(() => {
        this.getChannelList(query)
      }, 300)
    },
    getChannelDisplayName(item) {
      // 统一渠道显示格式，参考SingleTicketUser.vue
      if (item.realname || item.name) {
        const name = item.realname || item.name
        return item.alias ? `${name}(${item.alias})` : name
      }
      return item.alias || ''
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.$refs.channelForm.resetFields()
      
      // 清理搜索定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = null
      }
      
      // 重置数据
      this.formData.channel_id = ''
      this.channelOptions = []
      this.allChannels = []
    },
    async handleSubmit() {
      this.$refs.channelForm.validate(async (valid) => {
        if (valid) {
          if (!this.formData.channel_id) {
            this.$message.warning('请选择新渠道')
            return
          }
          
          this.submitLoading = true
          try {
            // 调用员工保渠道变更API
            const params = {
              id: this.formData.id,
              channel_id: parseInt(this.formData.channel_id)
            }
            
            const response = await ygbChangeChannel(params)
            
            if (response && response.err_code === 0) {
              this.$message.success('渠道变更成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(response.err_msg || '渠道变更失败')
            }
          } catch (error) {
            console.error('渠道变更失败:', error)
            this.$message.error('渠道变更失败: ' + (error.message || '网络错误'))
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.change-channel-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  
  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>